<script lang="ts" setup>
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";

import TgButton from "@/abc-dsk/components/Button/TgButton.vue";
import FocusedMessage from "@/components/FocusedMessage.vue";

const { t } = useI18n();
const router = useRouter();

const login = () => {
  window.parent.postMessage({ type: "abc:login" }, "*");
  router.push({ name: "iframe.waiting-for-authentication" });
};
</script>

<template>
  <FocusedMessage>
    <template #message>{{ t("iframe.login.message") }}</template>

    <template #button>
      <TgButton tag="button" size="lg" @click="login()">{{ t("iframe.login.button") }}</TgButton>
    </template>
  </FocusedMessage>
</template>
